/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-22 09:04:06
 * @LastEditTime : 2023-09-22 11:14:57
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_change\src\api\smart\warehouseControl.js
 */

import request from "@/utils/request";

export function queryWarehourse(params) {
  return request({
    url: "/icps/system/sign/intelligent/warehouseControl/queryWarehourse",
    method: "get",
    params,
  });
}
export function updateEnable(data) {
  return request({
    url: "/icps/system/sign/intelligent/warehouseControl/updateEnable",
    method: "post",
    data,
  });
}
export function operateAccessControl(data) {
  return request({
    url: "/icps/system/sign/intelligent/warehouseControl/operateAccessControl",
    method: "post",
    data,
  });
}